var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconVida = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: "new 0 0 40 40"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M36.1,5c2.4,2.1,3.7,4.7,3.9,8c0.2,3.2-0.9,6-3.1,8.2L21.8,36.8c-0.5,0.5-1.1,0.8-1.8,0.8 c-0.7,0-1.3-0.3-1.8-0.8L3.1,21.2c-2.2-2.2-3.3-5-3.1-8.2c0.2-3.2,1.5-5.9,3.9-8c2.1-1.8,4.6-2.6,7.4-2.4S16.5,4,18.4,6L20,7.6 L21.6,6c2-2,4.4-3.2,7.1-3.4C31.5,2.4,33.9,3.2,36.1,5z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconVida, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_vida.896647bc.svg";
export { ForwardRef as ReactComponent };